import React, { useState, useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { UserContext } from '../../context/UserContext';
import HrnbForm from "../controls/HrnbForm";
import HrnbFormControl from "../controls/HrnbFormControl";
import HrnbButton from "../controls/HrnbButton";
import { LoginIcon, RegisterIcon } from "../../icons";

export default function HrnbLoginForm({ onClose, onSwitchRegister }) {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const { signIn } = useContext(UserContext);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!username.trim() || !password) {
            alert("Заполните логин и пароль");
            return;
        }
        setLoading(true);
        try {
            await signIn({ username, password });
            navigate('/cabinet');
            if (onClose) onClose();
        } catch (err) {
            const msg = err?.response?.data?.message || err?.message || 'Ошибка авторизации';
            alert(msg);
        } finally {
            setLoading(false);
        }
    };

    const handleChange = setter => e => setter(e.target.value);

    return (
        <HrnbForm onSubmit={handleSubmit}>
            <HrnbFormControl
                as="text"
                value={username}
                onChange={handleChange(setUsername)}
                placeholder="Введите логин"
                label="Логин:"
                style={{ marginTop: 12 }}
                autoFocus
            />
            <HrnbFormControl
                as="password"
                value={password}
                onChange={handleChange(setPassword)}
                placeholder="Введите пароль"
                label="Пароль:"
                style={{ marginTop: 12 }}
            />
            <div style={{ marginTop: 8 }}>
                <Link to="/forgot-password" onClick={() => onClose && onClose()} style={{ fontSize: 14, color: '#0d6efd' }}>
                    Забыли пароль?
                </Link>
            </div>
            <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
                <HrnbButton
                    type="submit"
                    style={{ flex: 1 }}
                    icon={<LoginIcon />}
                    disabled={loading}
                >
                    {loading ? 'Вход...' : 'Войти'}
                </HrnbButton>
                <HrnbButton
                    type="button"
                    variant="ghost"
                    onClick={() => onSwitchRegister && onSwitchRegister()}
                    disabled={loading}
                    icon={<RegisterIcon />}
                >
                    Регистрация
                </HrnbButton>
            </div>
        </HrnbForm>
    );
}
